// extracted by mini-css-extract-plugin
export default {"section":"ReportSection_section__1-ZZS","title":"ReportSection_title__D-Y17","content":"ReportSection_content__bNNkL"};